/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row , Modal , Button} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import Translation from  '../../store/internationalization-store.js';

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            value:this.props.value || ""
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || ""
        };
    }

    onSave(){
        this.props.onSave(this.state.value)
        this.props.onHide();
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {this.props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <div >
                                <FieldGroup value={this.state.value} onChange={(event)=>{ this.setState({value:event.target.value}) }} className="strong" as="input" label={this.props.fieldTitle}  type="input" autofocus="true"/>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.onSave.bind(this)}>{Translation.get(657, "Save")}</Button> <Button onClick={this.props.onHide}>{Translation.get(629, "Close")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}